export default "__VITE_ASSET__CS7PiNPX__"